export default __webpack_public_path__ + "static/media/Kitchen_tools.844a81ec.jpg";